<template>
    <div class="comment">
        <!-- <a class="avatar">
            <img :src="avatar">
        </a> -->
        <div class="content">
            <a class="author">{{ comment.name }}</a>
            <div class="metadata">
                <span class="date">{{ human_datetime(comment.created_at) }}</span>
            </div>
            <div class="text">
                {{ comment.content || '-' }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        comment: Object,
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            errors: [],
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
        this.init()
    },
    computed: {
        avatar() {
            if (this.comment.staff_identity) {
                return "https://semantic-ui.com/images/avatar/small/matt.jpg"
            } else if (this.comment.customer_identity) {
                return "https://semantic-ui.com/images/avatar/small/elliot.jpg"
            }
        }
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
    },
    components: {
    }
}
</script>

<style scoped>
</style>
